<template>
  <v-container fluid class="pa-2 d-flex flex-column" style="height: calc(100vh - 64px);">
    <v-row>
      <!-- <v-col cols="12" xl="2" lg="3" md="4" sm="6">
        <v-autocomplete v-model="queryForm.postlineid" :items="postlines" label="线路"
          :menu-props="{ bottom: true, offsetY: true }" dense outlined no-data-text="无" @change="getdata()">
        </v-autocomplete>
      </v-col> -->
      <!-- <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-autocomplete v-model="queryForm.day_type" :items="[
          { text: '封车日期', value: 'block_t' },
          { text: '流水号日期', value: 'serial_t' },
        ]" label="查询方式" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined
          @change="getdata()">
        </v-autocomplete>
      </v-col>-->
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="start_menu" v-model="start_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_menu.save(queryForm.start_day); start_menu = false; getdata(); }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="end_menu" v-model="end_menu" :close-on-content-click="false" :return-value.sync="queryForm.end_day"
          transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_menu.save(queryForm.end_day); end_menu = false; getdata(); }"></v-date-picker>
        </v-menu>
      </v-col>
      <!-- <v-col cols="12" xl="1" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" label="车牌号" dense outlined clearable>
        </v-text-field>
      </v-col> -->
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-autocomplete v-model="queryForm.vehicle_type" :items="vehicleTypes" label="车型选择"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined hide-details
          @change="getdata()">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-btn @click="getdata()" color="primary" dark tile>
          <v-icon small>mdi-magnify</v-icon>查询
        </v-btn>
      </v-col>
    </v-row>
    <a-tabs v-model="type" size="small">
      <a-tab-pane :key="0" tab="汇总图表"></a-tab-pane>
      <a-tab-pane :key="1" tab="价格明细"></a-tab-pane>
    </a-tabs>
    <v-row class="flex-grow-1" style="min-height: 0; flex: 1 1 auto;">
      <v-col cols="12" xl="2" lg="3" md="4" sm="4" class="d-flex flex-column" style="min-height: 0;">
        <v-card tile class="flex-grow-1" style="overflow: hidden;">
          <a-table size="small" :columns="postlineColumns" :data-source="postlines" row-key="value" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" :scroll="{ x: 110, y: height }" :rowClassName="postlineRowClass"
            :customRow="postlineCustomRow" @rowClick="handleRowClick">
          </a-table>
        </v-card>
      </v-col>
      <v-col v-if="type == 0" cols="12" xl="10" lg="9" md="8" sm="8" class="d-flex flex-column" style="min-height: 0;">
        <v-card tile class="flex-grow-1" style="overflow: hidden;">
          <apexchart width="100%" height="100%" :options="options" :series="series"></apexchart>
        </v-card>
      </v-col>
      <v-col v-if='type == 1' cols="12" xl="10" lg="9" md="8" sm="8" class="d-flex flex-column" style="min-height: 0;">
        <v-data-table dense :headers="infoHeader" :items="tablelist" :items-per-page="tablelist.length"
          no-data-text="无数据" hide-default-footer disable-sort fixed-header :height="height">
          <template slot="postline">
            {{ currentPostlineText }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import _ from "underscore";
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
export default {
  name: "FinanceSelfBillChart",
  data() {
    return {
      type: 0,
      own_type: 0,
      queryForm: {
        postlineid: "",
        day_type: "block_t",
        start_day: this.$moment().subtract(1, 'month').format("YYYY-MM-DD"),
        end_day: this.$moment().format("YYYY-MM-DD"),
        vehicle_type: "12吨"
      },
      start_menu: false,
      end_menu: false,
      postlines: [],
      vehicleTypes: [
        { text: '12吨', value: '12吨' },
        { text: '30吨', value: '30吨' },
      ],
      list: [],
      height: 700,
      tablelist: [],
      // 邮路列表专用表头
      postlineColumns: [
        { title: "线路名称", dataIndex: "text", width: 110, align: "center" },
      ],
      infoHeader: [
        { text: "价格", value: "price", width: 120, align: "center", },
        { text: "车牌号", value: "vehicle_number", width: 120, align: "center", },
        { text: "司机", value: "driver_name", width: 120, align: "center", },
        { text: "车型", value: "vehicle_type", width: 120, align: "center", },
        { text: "调车日期", value: "day", width: 120, align: "center", },
        { text: "调车员", value: "dispatcher", width: 120, align: "center", },
      ],
    };
  },
  computed: {
    options() {
      return {
        chart: {
          type: "line",
          zoom: { enabled: false }
        },
        xaxis: { categories: _.pluck(this.list, "day").reverse() }
      };
    },
    series() {
      return [
        {
          name: '调车费',
          data: _.pluck(this.list, "freight").reverse()
        }
      ];
    },
    // 当前选中的邮路文本
    currentPostlineText() {
      const found = (this.postlines || []).find((r) => r.value == this.queryForm.postlineid);
      return found ? found.text : '';
    },
  },
  components: {},
  watch: {

  },
  mounted() {
    this.computeHeight();
    window.onresize = (e) => {
      this.computeHeight();
    };
  },
  activated() {
    this.list = [];
    this.queryForm = {
      postlineid: "",
      day_type: "block_t",
      start_day: this.$moment().subtract(1, 'month').format("YYYY-MM-DD"),
      end_day: this.$moment().format("YYYY-MM-DD"),
      vehicle_type: "12吨",
    };
    this.getdata();
  },
  methods: {
    // 邮路列表行 class：与当前选中项 value 相等时返回高亮类名
    postlineRowClass(record) {
      if (String(record.value) === String(this.queryForm.postlineid)) {
        return 'postline-row-active';
      }
      return '';
    },
    // 处理邮路列表行点击事件
    handleRowClick(record, index, event) {
      console.log('row click', record);
      if (!record || record.value == null) return;

      this.queryForm.postlineid = record.value;
      this.getdata();
    },
    // 邮路列表行属性（1.x API）：on.click + style + class
    postlineCustomRow(record) {
      return {

        style: 'cursor: pointer;',
        class: String(record.value) === String(this.queryForm.postlineid) ? 'postline-row-active' : '',
      };
    },
    // 计算高度
    computeHeight() {
      // 父容器总高 calc(100vh - 64px)，扣除顶部工具栏+tabs+padding 共占约 180px
      const h = window.innerHeight - 64 - 180;
      this.height = Math.max(400, h);
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfbillchart/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          // 右侧"调车日期"列倒序：最新在上
          // YYYY-MM-DD 字符串可直接字典序比较
          this.tablelist = (res.data.list || []).slice().sort((a, b) => {
            const ad = a.day || "";
            const bd = b.day || "";
            if (ad === bd) return 0;
            return ad < bd ? 1 : -1;
          });
          this.list = this.makelist(res.data.list);
          this.postlines = res.data.postlines;
          this.queryForm.postlineid = res.data.postlineid;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makelist(list) {
      let result = {};
      for (let i = 0; i < list.length; i++) {
        let { dispatch_no, price, day } = list[i];
        if (!result[day]) {
          result[day] = {
            day,
            t: list[i][this.queryForm.day_type],
            freight: this.$utils.d(),
            count: 0
          };
        }
        if (this.$d(price).gt(0)) {
          result[day].count++;
          result[day].freight = result[day].freight.plus(price || 0);
        }
      }
      result = _.values(result).filter(n => n.count > 0).sort((a, b) => b.t - a.t).map(n => {
        return {
          day: n.day,
          freight: Number(n.freight.div(n.count).toFixed(2)),
        };
      }).filter(n => Number(n.freight) > 0);
      return result;
    },
  },
};
</script>
<style lang="less" scoped>
// 邮路列表选中行高亮
/deep/ .ant-table-tbody>tr.postline-row-active>td,
/deep/ .ant-table-tbody>tr.postline-row-active:hover>td {
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-weight: 600;
  // border-left: 3px solid #1890ff;
}

/deep/ .v-autocomplete .v-input__icon,
/deep/ .v-select .v-input__icon {
  width: 24px !important;
  min-width: 24px !important;
}

/deep/ .v-autocomplete .v-input__icon>.v-icon,
/deep/ .v-select .v-input__icon>.v-icon {
  font-size: 16px !important;
}

/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>